<article class="card event-teaser-card p-1 bg-primary mb-3">
  <a [routerLink]="linkToContent" class="event-teaser-card__inner block-link">
    <header class="event-teaser-card__header p-3">
      <h1 class="h3 font-primary text-light">{{ comingSoonText }}</h1>
      <span class="type-body-md text-light fw-bold">{{ contentTypeText }}</span>
      <div class="event-teaser-card__wrapper text-secondary mt-2">
        <h2 class="type-body-md fw-bold font-secondary event-teaser-card__title mb-0">{{ subtitle }}</h2>
      </div>
      <a [routerLink]="linkToContent" class="button button-link button--light ps-0 align-self-start mt-2">
        <span class="mb-0 text-light">{{ linkText }}</span>
        <app-icon anchor="icon-arrow-right"></app-icon>
      </a>
    </header>
    <aside class="event-teaser-card__date event-date event-date--chip">
      <h1 class="event-date__day">{{ date | date : 'd' }}</h1>
      <span class="event-date__month">{{ date | date : 'MMM' }}</span>

      <span class="date font-secondary text-primary">{{ date | date : 'shortTime' }}</span>
    </aside>
  </a>
</article>
